import {all} from 'redux-saga/effects';
import auth, {authSaga} from './auth';
import loading from './loading';
import dashboard, {dashboardSaga} from './admin/dashboard';
import database, {databaseSaga} from './admin/database';
import docs, {docsSaga} from './admin/docs';
import adminFeedback, {adminFeedbackSaga} from './admin/feedback';
import voca, {vocaSaga} from './admin/voca';
import chat, {chatSaga} from './chat/chat';
import download, {downloadSaga} from './chat/download';
import feedback, {feedbackSaga} from './chat/feedback';

const rootReducer = {
    auth,
    loading,
    dashboard,
    database,
    docs,
    adminFeedback,
    voca,
    chat,
    download,
    feedback
};

export function* rootSaga() {
    yield all([authSaga(), dashboardSaga(), databaseSaga(), docsSaga(), adminFeedbackSaga(), vocaSaga(), chatSaga(), downloadSaga(), feedbackSaga()]);
}

export default rootReducer;
